import styled from 'styled-components';

export const FuturaTarjetaWrapper = styled.div`

._3sTov _35oaN{
    margin: 10px;
}

.futura-tarjeta-header-blue {
    background: rgb(2,119,170);
    background: linear-gradient(180deg, rgba(1,140,198,1) 0%, rgba(139,212,240,1) 87%, rgba(184,227,244,1) 100%);
    border-radius: 5px;
    margin: 0px 0 32px 0;
    height: 250px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-content: center;
    padding: 60px 60px 34px 60px;
    align-items: center;
    
}

.Card-Class{
    background: white;
    margin-bottom: 35px;
}

.p-dale {
    max-width: 210px;
}

.t-internacional img {
    position: relative;
    left: 30px;
}

.p-internacional {
    color: white;
    font-weight: bold;
    
}

.img.tarjetainternacional.mobile{
    display:none;
}


.p-internacional-dos {
    color: white;
}

.futura-tarjeta-header-blue .p-dale {
    position: relative;
    left: 45px;
    bottom: 36px;
    color: white;
    font-size: 0.8rem;
    font-weight: 500;
}

.t-internacional .titulo {
    font-size: 1.5rem;
    line-height: 1.5;
    font-weight: bold;
    color: white;
}

.t-internacional .subtitulo {
    font-size: 0.9rem;
    color: #FFFFFF;
    font-weight: 300;
}

p.p-internacional-dos {
    position: relative;
    top: 20px;
    font-size: 0.8rem;
    font-weight: 500;
}

.t-internacional .texto {
    position: relative;
    left: 49px;
    bottom: 76px;
}

.card {
    margin-top: 16px;
    background-color: white;
    border-radius: 5px;
    margin-bottom: 30px;

    
}


.contenedor{
    display: grid;
    justify-content: center;
    align-items: center;
}

.contenedor-blue-card {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    text-align: center;
}


.p-mensaje {
    margin-top: 0.5rem;
    font-size: 0.9rem;
    margin-bottom: 8px;
    font-weight: 600;
}

.info .p-coment {
    font-size: 0.8rem;
    line-height: 17px;
    color: #333333;
}


.contenedor-blackcard .info {
    padding: 10px;
}

.tarjetadale {
    margin: 56px;
    margin-left: 57%;
}

@media (min-width: 420px){
    .tarjetainternacional.desktop{
        display:none;
    }
    .t-internacional-texto {
        padding-bottom:30px;
    }
}

@media (max-width: 426px){ 

    img.tarjetainternacional.desktop{
        display:none;
    }

    .futura-tarjeta-header-blue .t-internacional:nth-child(2){
        text-align: center;   
    }

    img.tarjetainternacional.mobile{
        display:block;
    }
    .futura-tarjeta-header-blue .p-dale{
        margin-left: 16px;
        left: 48px;
        width: 132px;
    }
    .t-internacional img {
        position: relative;
        left: 0;
        margin: 0 auto;
        width: inherit;
    }
    .futura-tarjeta-header-blue {
        margin: 0px -10px -52px -10px;
        padding: 10px;
        height: auto;
    }

    .t-internacional .texto {
        width: 200px;
        position: relative;
        left: 16px;
        bottom: 76px;
    }
    .futura-tarjeta-header-blue{
        grid-template-columns: 1fr;
    }
    .futura-tarjeta-header-blue .t-internacional:nth-child(1) {
        padding: 15px;
    }
    .futura-tarjeta-header-blue .t-internacional:nth-child(1) .titulo{
        font-size: 1rem;
        margin-left: 44px;
    }
    .futura-tarjeta-header-blue .t-internacional:nth-child(1) .subtitulo{
        font-size: 0.9rem;
        line-height: 19px;
        display: none;
    }
    .contenedor-blue-card{
        grid-template-columns: 1fr;
    }
    .contenedor-blue-card {
        gap: 20px;
    }
    .Card-Class {

        margin-top: 36px;

    }
    .Card-Class h1 {
        font-size: 1.1rem !important;
    }
    .card {
        margin-top: 16px;
    }
}

@media (max-width: 376px){ 
    img.tarjetainternacional.desktop{
        display:none;
    }

    img.tarjetainternacional.mobile{
        display:block;
    }
    .futura-tarjeta-header-blue .p-dale{
        margin-left: 16px;
        left: 24px;
        width: 140px;
    }
    .t-internacional img {
        position: inherit;
        left: 0;
        margin: 0 auto;
        width: inherit;
    }
    .futura-tarjeta-header-blue {
        margin: 0px -10px -52px -10px;
        padding: 10px;
        height: auto;
    }

    .t-internacional .texto {
        width: 200px;
        position: relative;
        left: 16px;
        bottom: 94px;
    }
    .futura-tarjeta-header-blue{
        grid-template-columns: 1fr;
    }
    .futura-tarjeta-header-blue .t-internacional:nth-child(2){
        text-align: center;   
    }
    .futura-tarjeta-header-blue .t-internacional:nth-child(1) {
        padding: 15px;
    }
    .futura-tarjeta-header-blue .t-internacional:nth-child(1) .titulo{
        font-size: 1rem;
        margin-left: 20px;
    }
    .futura-tarjeta-header-blue .t-internacional:nth-child(1) .subtitulo{
        font-size: 0.9rem;
        line-height: 19px;
        display: none;
    }
    .contenedor-blue-card{
        grid-template-columns: 1fr;
    }
    .contenedor-blue-card {
        gap: 20px;
    }
    .Card-Class {

        margin-top: 36px;

    }
    .Card-Class h1 {
        font-size: 1.1rem !important;
    }
    .card {
        margin-top: 16px;
    }
}


@media (max-width: 321px){
    img.tarjetainternacional.desktop{
        display:none;
    }

    img.tarjetainternacional.mobile{
        display:block;
    }
   .futura-tarjeta-header-blue .p-dale{
        margin-left: 16px;
        left: -3px;
        width: 130px;
    }
    .t-internacional img {
        position: relative;
        left: 0;
        margin: 0 auto;
        width: inherit;
    }
    .futura-tarjeta-header-blue .t-internacional:nth-child(2){
        text-align: center;   
    }
    .futura-tarjeta-header-blue {
        margin: 0px -10px -52px -10px;
        padding: 10px;
        height: auto;
    }

    .t-internacional .texto {
        width: 200px;
        position: relative;
        left: 16px;
        bottom: 82px;
    }
    .futura-tarjeta-header-blue{
        grid-template-columns: 1fr;
    }
    .futura-tarjeta-header-blue .t-internacional:nth-child(1) {
        padding: 15px;
    }
    .futura-tarjeta-header-blue .t-internacional:nth-child(1) .titulo{
        font-size: 1rem;
        margin-left: 0px;
    }
    .futura-tarjeta-header-blue .t-internacional:nth-child(1) .subtitulo{
        font-size: 0.9rem;
        line-height: 19px;
        display: none;
    }
    .contenedor-blue-card{
        grid-template-columns: 1fr;
    }
    .contenedor-blue-card {
        gap: 20px;
    }

    .Card-Class {

        margin-top: 36px;

    }
    .Card-Class h1 {
        font-size: 1.1rem !important;
    }
    .card {
        margin-top: 16px;
    }


}

`;

export default FuturaTarjetaWrapper;